function openUrlencodedTarget(event) {
    // Un contrôle de fermeture (croix, data-bs-dismiss) à l'intérieur d'une zone
    // urlencoded ne doit jamais ouvrir le lien affilié (ex. croix de la bannière Nenustay)
    if (event.target.closest && event.target.closest(".btn-close, [data-bs-dismiss]")) {
        return;
    }

    // Vérifie si l'élément activé ou un de ses parents a la classe 'urlencoded'
    var target = event.target;
    while (target && target.classList && !target.classList.contains("urlencoded")) {
        target = target.parentNode;
        if (target === document.body) return; // Stoppe si 'body' est atteint
    }

    if (target) {
        var attribute = target.getAttribute("data-urlencoded");
        var url = decodeURIComponent(window.atob(attribute));

        if (typeof _paq !== "undefined") {
            _paq.push(['trackLink', url, 'link']);
        }

        if (target.getAttribute("data-target") === "self") {
            document.location.href = url;
        } else {
            var newWindow = window.open(url, '_blank');
            newWindow.focus();
        }
    }
}

document.body.addEventListener("click", openUrlencodedTarget);

document.body.addEventListener("keydown", function(event) {
    if (event.key !== "Enter") return;
    openUrlencodedTarget(event);
});
